import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=652e573c&"
import script from "./LatestArticles.vue?vue&type=script&lang=js&"
export * from "./LatestArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports